import React from "react";
import { secondaryTextColorOppositeShade } from "../../utils/constants";

export default function AddProfileDetailsIcon({ color = secondaryTextColorOppositeShade }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 82.99 82.99">
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Ebene_1-2" data-name="Ebene 1">
          <path
            fill={color}
            d="M41.5,83A41.5,41.5,0,1,0,0,41.5,41.59,41.59,0,0,0,41.5,83Zm0-78.13A36.64,36.64,0,1,1,4.86,41.5,36.68,36.68,0,0,1,41.5,4.86Z"
          />
          <path
            fill={color}
            d="M41.5,73.27A31.77,31.77,0,1,0,9.73,41.5,31.9,31.9,0,0,0,41.5,73.27Zm0-58.68A26.91,26.91,0,1,1,14.59,41.5,26.94,26.94,0,0,1,41.5,14.59Z"
          />
          <path
            fill={color}
            d="M41.5,34.2a7.3,7.3,0,1,0-7.3-7.29A7.3,7.3,0,0,0,41.5,34.2Zm0-9.72a2.43,2.43,0,1,1-2.44,2.43A2.43,2.43,0,0,1,41.5,24.48Z"
          />
          <path
            fill={color}
            d="M31.77,43.93H34.2V61.11a2.43,2.43,0,0,0,2.43,2.43h9.73a2.43,2.43,0,0,0,2.43-2.43V41.5a2.43,2.43,0,0,0-2.43-2.44H31.77a2.44,2.44,0,0,0,0,4.87ZM43.93,58.68H39.06V43.93h4.87Z"
          />
        </g>
      </g>
    </svg>
  );
}
